<script>
    import { createEventDispatcher, onMount } from "svelte";
    import Constantes from "../Classes/Constantes";
    export let saida;
    let selectedDates = [];
    let showModal = false;
    let hoje = new Date();
    let currentMonth = new Date().getMonth();
    let currentYear = new Date().getFullYear();
    let classeSelecao = {};
    let treinos = {};
    export let id_usuario;
    export let dias = [];
    const daysOfWeek = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
    const dispatch = new createEventDispatcher();
    function toggleDate(date) {
        const formattedDate = formatDate(date);
        if (selectedDates.includes(formattedDate)) {
            selectedDates = selectedDates.filter((d) => d !== formattedDate);
        } else {
            selectedDates = [...selectedDates, formattedDate];
        }
    }

    function formatDate(date) {
        if (date instanceof Date) {
            return date.toISOString().split("T")[0];
        }
        return date;
    }

    function BaixarPlanilha() {
    window.location.href =
      Constantes.api_gerar_planilha+"?mes="+(currentMonth+1)+"&ano="+currentYear+"&id_usuario="+id_usuario;
  }

function AlimentaLista() {
    dias.forEach((element) => {
        if (element.treinos.length > 0) {
            let treinoDate = element.treinos[0].data;
            treinoDate.setDate(treinoDate.getDate() );  // Subtrai um dia

            let data = formatDate(treinoDate);  // Agora 'data' será a data ajustada
            console.log("data ", data)

            let treino = formatDate(element.treinos[0]);

            classeSelecao[data] =
                element.treinos[0].data.getTime() < hoje.getTime() &&
                treino.feito == 0
                    ? "data_anterior"
                    : treino.feito == 2
                        ? "feito"
                        : treino.feito == 1
                            ? "feito_parcial"
                            : "selected";
            console.log(data);
            treinos[data] = treino;
        }
    });

    console.log(classeSelecao);
}

    onMount(() => {
        console.log("dias ", dias)
        dates = getDaysInMonth(currentYear, currentMonth);
        AlimentaLista();
    });

    function DiaSelecionado(data) {
        dispatch("selecionado", treinos[data]);
        console.log(treinos[data]);
    }
    function getDaysInMonth(year, month) {
        const dates = [];
        const date = new Date(year, month, 1);
        const firstDay = date.getDay();

        // Add blank days for the first week
        for (let i = 0; i < firstDay; i++) {
            dates.push(null);
        }

        while (date.getMonth() === month) {
            dates.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }

        return dates;
    }

    function changeMonth(direction) {
        if (direction === "prev") {
            currentMonth--;
            if (currentMonth < 0) {
                currentMonth = 11;
                currentYear--;
            }
        } else if (direction === "next") {
            currentMonth++;
            if (currentMonth > 11) {
                currentMonth = 0;
                currentYear++;
            }
        }
        dates = getDaysInMonth(currentYear, currentMonth);
    }

    let dates = [];
    function closeModal() {
        showModal = false;
    }
</script>

<div class="container"></div>

<div
    class="container"
    tabindex="-1"
    aria-labelledby="calendarModalLabel"
    aria-hidden="true"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header"></div>
            <div class="modal-body">
                <div class="card">
                    <div class="card-header">
                        <div class="d-flex justify-content-between">
                            <span
                                class="arrow"
                                on:click={() => changeMonth("prev")}>❮</span
                            >
                            <span>
                                {new Date(
                                    currentYear,
                                    currentMonth,
                                ).toLocaleDateString("default", {
                                    month: "long",
                                    year: "numeric",
                                })}
                            </span>
                            <span
                                class="arrow"
                                on:click={() => changeMonth("next")}>❯</span
                            >
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="days-of-week">
                            {#each daysOfWeek as day}
                                <div>{day}</div>
                            {/each}
                        </div>
                        <div class="calendar">
                            {#each dates as date}
                                <div
                                    class="day {classeSelecao[
                                        formatDate(date)
                                    ]}"
                                    on:click={() => {
                                        DiaSelecionado(formatDate(date));
                                    }}
                                >
                                    {date ? date.getDate() : ""}
                                </div>
                            {/each}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<br> <div class="d-flex justify-content-center">
<button class='botao_baixar' on:click={BaixarPlanilha}>Baixar planilha em pdf</button>
</div>

<style>
   .botao_baixar {
    background-color: #757575; /* Fundo cinza claro */
    border-bottom: 1px solid #dcdcdc; /* Linha separadora */
    padding: 5px 10px; /* Menor padding */
    font-size: 0.85rem; /* Texto menor */
    text-align: center; /* Alinhamento à esquerda */
    width: 90%;
    color:white;
  }
   
   .modal.d-block {
        display: block;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .calendar {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 5px;
    }

    .day {
        padding: 10px;
        text-align: center;
        cursor: pointer;
    }

    .selected {
        background-color: grey;
        color: white;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }

    .days-of-week {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 5px;
        text-align: center;
    }

    .arrow {
        cursor: pointer;
    }

    .selected-dates-container {
        margin-top: 10px;
    }

    .btn-outline-secondary {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .fa-trash {
        pointer-events: none;
    }
    .data_anterior {
        background-color: red;
    }
    .feito_parcial {
        background-color: yellow;
    }
    .feito {
        background-color: green;
    }
</style>
